"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = require("react");
var useScrollToElementEffect = function useScrollToElementEffect(ref, shouldScroll) {
  (0, _react.useEffect)(function () {
    if (!ref || !shouldScroll) {
      return;
    }
    setTimeout(function () {
      var _el;
      var el;
      if (typeof ref === 'string') {
        el = document.querySelector(ref);
      } else if ('current' in ref) {
        el = ref.current;
      } else {
        el = ref;
      }
      (_el = el) === null || _el === void 0 || _el.scrollIntoView();
    }, 0);
  }, [ref, shouldScroll]);
};
var _default = exports["default"] = useScrollToElementEffect;
//# sourceMappingURL=useScrollToElementEffect.js.map